/**
 * 영구 스탯 강화 정의 — 골드 소모(statUpgrades.tsv) + 환생 포인트 소모(rebirthUpgrades.tsv).
 * 수치는 TSV에서 수정 후 `npm run export:data`.
 */
import statUpgradesJson from "../generated/statUpgrades.json";
import rebirthUpgradesJson from "../generated/rebirthUpgrades.json";

/** 골드 소모 영구 스탯 강화 1종 정의. */
export interface StatUpgradeDef {
  /** 레벨 0 → 1 강화 기준 비용. */
  readonly baseCost: number;
  /** 비용 산식 — `{base}`(=baseCost)/`{level}` 플레이스홀더. cost = round(evalStatExpression(costExpr, baseCost, level)). 지수식이라 effect(선형)보다 가팔라 레벨↑ 시 코스트 대비 효율 감소. */
  readonly costExpr: string;
  /** expression `{base}` 치환값 (효과 계수). */
  readonly base: number;
  /** 효과 산식 — `{base}`/`{level}` 플레이스홀더. effect = evalStatExpression(expression, base, level). 선형이라 cost(지수)보다 완만. */
  readonly expression: string;
  /** 최대 강화 레벨. */
  readonly maxLevel: number;
}

/**
 * 골드 소모 영구 스탯 강화 정의 (statUpgrades.tsv). statId별 비용 누진·효과·만렙.
 * 효과 적용은 StatUpgradeController + GameScene (attack=기본 피해, fireRate=발사 간격,
 * goldGain=골드 획득 배수). projectileSpeed는 폐기(2026-06-09 — DPS 무관해 의미 없음).
 */
export const STAT_UPGRADE_DEFS: Record<string, StatUpgradeDef> = Object.fromEntries(
  statUpgradesJson.map((d) => [
    d.statId,
    {
      baseCost: d.baseCost,
      costExpr: d.costExpr,
      base: d.base,
      expression: d.expression,
      maxLevel: d.maxLevel,
    },
  ]),
);

/**
 * 환생 포인트 소모 영구 강화 정의 (rebirthUpgrades.tsv). statUpgrades와 동일 스키마(StatUpgradeDef) —
 * StatUpgradeController에 defs로 주입해 재사용한다. 비용 단위는 골드가 아닌 환생 포인트(작은 정수 누진).
 * 4종: attack=기본 피해 가산, fireRate=발사 간격 감소(ms), goldGain=골드 배수, pointBonus=환생 적립 포인트 가산.
 * (기존 permanentDamageBonus는 v8 마이그레이션에서 attack 레벨로 흡수 — 이관 비율은 permanentDamagePerPoint=1.
 * 이후 attack base가 10으로 ×10 스케일되어 이관 레벨의 효과도 baseDamage·brickBaseHp 전체 ×10과 동률 유지.)
 */
export const REBIRTH_UPGRADE_DEFS: Record<string, StatUpgradeDef> = Object.fromEntries(
  rebirthUpgradesJson.map((d) => [
    d.statId,
    {
      baseCost: d.baseCost,
      costExpr: d.costExpr,
      base: d.base,
      expression: d.expression,
      maxLevel: d.maxLevel,
    },
  ]),
);
